module.exports = __webpack_public_path__ + "media/metal_sheet_1.1fba635c.webm";